export const serviceName = 'modal';
